import {
    START_COMPARABLE_REQUEST,
    START_COMPARABLE_SUCCESS,
    START_COMPARABLE_FAILURE,
    PING_COMPARABLE_REQUEST,
    PING_COMPARABLE_SUCCESS,
    PING_COMPARABLE_FAILURE,
    CANCEL_COMPARABLE_REQUEST,
    CANCEL_COMPARABLE_SUCCESS,
    CANCEL_COMPARABLE_FAILURE,
    EXPORT_COMPARABLE_REQUEST,
    EXPORT_COMPARABLE_SUCCESS,
    EXPORT_COMPARABLE_FAILURE
} from './Types';

import axios, { CancelTokenSource } from 'axios';
import { debounce } from 'lodash';
import { Comparable } from './comparableTypes';
import { Criteria, Geometry } from '../../utility/Types/commonTypes';

const CancelToken = axios.CancelToken;
let startComparableSource: CancelTokenSource | null, pingComparableSource: CancelTokenSource | null;

const startComparable = () => ({ type: START_COMPARABLE_REQUEST });
const startComparableSuccess = (comparable:Comparable) => ({ type: START_COMPARABLE_SUCCESS, comparable });
const startComparableError = (error: any) => ({ type: START_COMPARABLE_FAILURE, error });
const pingComparable = () => ({ type: PING_COMPARABLE_REQUEST });
const pingComparableSuccess = (comparable: Comparable) => ({ type: PING_COMPARABLE_SUCCESS, comparable });
const pingComparableError = (error:any) => ({ type: PING_COMPARABLE_FAILURE, error });
const cancelComparable = () => ({ type: CANCEL_COMPARABLE_REQUEST });
const cancelComparableSuccess = () => ({ type: CANCEL_COMPARABLE_SUCCESS });
const cancelComparableError = (error:any) => ({ type: CANCEL_COMPARABLE_FAILURE, error });
const exportComparable = () => ({ type: EXPORT_COMPARABLE_REQUEST });
const exportComparableSuccess = () => ({ type: EXPORT_COMPARABLE_SUCCESS });
const exportComparableError = (error:any) => ({ type: EXPORT_COMPARABLE_FAILURE, error });

const ping = (dispatch: (arg0: { type: string; comparable?: Comparable; error?: any; }) => void, id: any) => {
    pingComparableSource && pingComparableSource.cancel('Cancelling already running request');
    dispatch(pingComparable());
    return axios.get(`/api/comparables/${id}`, {
        cancelToken: (pingComparableSource = axios.CancelToken.source()).token
    }).then(response => {
        pingComparableSource = null;
        dispatch(pingComparableSuccess(response.data));
        // If still running then ping again
        if (response.data.status === 'ready' || response.data.status === 'queued' || response.data.status === 'running') {
            debouncedPing(dispatch, response.data.id);
        }
    }).catch(error => {
        pingComparableSource = null;
        if (axios.isCancel(error)) {
            console.log('cancel', error);
        } else {
            dispatch(pingComparableError(error.response));
            console.error(error);
        }
    });
};

const debouncedPing = debounce(ping, 3000);

export const startComparableAsync = (geometry:Geometry, criteria:Criteria) => {
    return (dispatch: (arg0: { type: string; comparable?: Comparable | undefined; error?: any; }) => void) => {
        cancelRequests();

        dispatch(startComparable());
        return axios.post('/api/comparables', {
            geometry: geometry,
            criteria: criteria
        }, {
            cancelToken: (startComparableSource = axios.CancelToken.source()).token
        }).then(response => {
            startComparableSource = null;
            dispatch(startComparableSuccess(response.data));
            debouncedPing(dispatch, response.data.id);
        }).catch(error => {
            startComparableSource = null;
            if (axios.isCancel(error)) {
                console.log('cancel');
            } else {
                dispatch(startComparableError(error.response));
                console.error(error);
            }
        });
    };
};

export const cancelComparableAsync = (id:number) => {
    return (dispatch: (arg0: { type: string; error?: any; }) => void) => {
        cancelRequests();

        dispatch(cancelComparable());
        return axios.patch(`/api/comparables/${id}/cancel`, {

        }).then(response => {
            dispatch(cancelComparableSuccess());
        }).catch(error => {
            dispatch(cancelComparableError(error.response));
            console.error(error.response);
        });
    };
};

export const exportComparableAsync = (id:number) => {
    return (dispatch: (arg0: { type: string; error?: any; }) => void) => {
        dispatch(exportComparable());
        return axios.post(`/api/comparables/${id}/export`, {

        }).then(response => {
            // Download Begin
            // Apparently this is a standard way to download a file directly, whether this should be done from Redux? Probably not
            // "Proper" way would be to use standard href to download but also add on click functionality that routinely checks request
            // to see if it has finished
            const filenameRegex = /filename="?([^"]+)"?/;
            const filename = response.headers['content-disposition'].match(filenameRegex)[1];
            const element = document.createElement('a');
            element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(response.data));
            element.setAttribute('download', filename);
            element.style.display = 'none';
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
            // Download End
            dispatch(exportComparableSuccess());
        }).catch(error => {
            dispatch(exportComparableError(error.response));
            console.error(error.response);
        });
    };
};

const cancelRequests = () => {
    debouncedPing.cancel();
    pingComparableSource && pingComparableSource.cancel('Operation cancelled by user');
    startComparableSource && startComparableSource.cancel('Cancelling already running request');
};